import React from 'react'
import './Dashboard.scss'
import LandingPage from '../../component/Layout/Dashboard/LandingPage'
import { useSelector } from 'react-redux'
import BreadCrumbComp from '../../component/breadCrumb/breadCrump'
const Dashboard = () => {
  const { steppersData } = useSelector((state) => state.crumbs)
console.log(steppersData)
  return (
    <div>
        {/* <BreadCrumbComp items={steppersData.dataDashboardSteps} /> */}

      <LandingPage/>
    </div>
  )
}

export default Dashboard
